import { render, staticRenderFns } from "./AddConfirm.vue?vue&type=template&id=37240a69&scoped=true"
import script from "./AddConfirm.vue?vue&type=script&lang=ts"
export * from "./AddConfirm.vue?vue&type=script&lang=ts"
import style0 from "./AddConfirm.vue?vue&type=style&index=0&id=37240a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37240a69",
  null
  
)

export default component.exports